import styled, { css } from "styled-components";

import { colors, radii } from "shared/ui/tokens";

import { MOBILE_BREAKPOINT } from "features/MenuEditor/styles";

/*
* Шапка ужимается в два приёма (правила макета):
*   ≥1280 — «Стоп-лист» с подписью, «Управление меню» с подписью, «+ Позиция»;
*   960–1279 — стоп-лист становится квадратной кнопкой 44×44 с бейджем в углу;
*   <960 — кнопки ужимаются до 40×40, но рамку сохраняют: без неё иконки на белой
*     шапке теряются.
* */
const COMPACT_HEADER_BREAKPOINT = 1280;

export const Toolbar = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;

    @media (max-width: ${MOBILE_BREAKPOINT - 1}px) {
        gap: 6px;
    }
`;

export const WideAction = styled.div`
    @media (max-width: ${COMPACT_HEADER_BREAKPOINT - 1}px) {
        display: none;
    }
`;

/*
* Правило вешаем на контейнер, а не через styled(IconButton): у обёртки над компонентом
* кита класс может оказаться в таблице стилей раньше собственного класса примитива, и
* переопределение молча не применится. Селектор по потомку выигрывает гарантированно.
* */
const compactIconButton = css`
    @media (max-width: ${MOBILE_BREAKPOINT - 1}px) {
        button {
            width: 40px;
            height: 40px;
        }
    }
`;

export const CompactAction = styled.div`
    position: relative;
    display: none;

    @media (max-width: ${COMPACT_HEADER_BREAKPOINT - 1}px) {
        display: block;
    }

    ${compactIconButton}
`;

export const WideManage = styled.div`
    @media (max-width: ${MOBILE_BREAKPOINT - 1}px) {
        display: none;
    }
`;

export const CompactManage = styled.div`
    display: none;

    @media (max-width: ${MOBILE_BREAKPOINT - 1}px) {
        display: block;
    }

    ${compactIconButton}
`;

export const InlineBadge = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 20px;
    height: 20px;
    padding: 0 6px;
    border-radius: ${radii.badge};
    background: ${colors.dangerBg};
    color: ${colors.danger};
    font-size: 12px;
    font-weight: 700;
`;

// Бейдж поверх свёрнутой кнопки — залитый, в углу: подписи рядом уже нет, и цифру
// должно быть видно с первого взгляда.
export const CornerBadge = styled.span`
    position: absolute;
    top: -6px;
    right: -6px;
    min-width: 20px;
    height: 20px;
    padding: 0 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: ${radii.badge};
    background: ${colors.danger};
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    pointer-events: none;

    @media (max-width: ${MOBILE_BREAKPOINT - 1}px) {
        top: 2px;
        right: 2px;
        min-width: 16px;
        height: 16px;
        padding: 0 4px;
        font-size: 10px;
    }
`;

